import { gql } from "@apollo/client";

const ADD_USEFUL_INFO = gql`
mutation addUsefulInfo($usefulInfoInput: UsefulInfoInput!)
    {addUsefulInfo(usefulInfoInput: $usefulInfoInput)
}`
;

export default ADD_USEFUL_INFO;
